<template>
  <GalleryView
    :load-gallery-media="loadMoreMedia"
    :sortable="isSortable"
    :total-gallery-media="totalEventMedia"
    :optimistic-update="true"
    :open-event="openEvent"
    @reorder="handleReorder"
    :id="'event_' + event.id"
  >
    <template v-slot:header>
      <div
        style="width: 100%"
        class="d-flex align-center justify-space-between"
      >
        <Header style="word-break: break-word" :level="4">{{
          event.title
        }}</Header>
        <IconButton
          tooltip="Galerie herunterladen"
          class="ml-4"
          @click="onDownloadClick"
          :icon="mdiDownload"
        />
      </div>
    </template>
    <template v-slot:activator="{ on, attrs }">
      <slot name="activator" :on="on" :attrs="attrs" />
    </template>
  </GalleryView>
</template>

<script lang="ts">
import { computed, defineComponent, inject, PropType } from "vue"
import { DetailedEvent } from "suus-api"
import GalleryView, {
  LoadGalleryMediaFunction,
} from "features/gallery/view/GalleryView.vue"
import Header from "components/UI/Header.vue"
import { getHighlightsGalleryMedia } from "features/events/highlights/highlights.functions"
import { GalleryService } from "features/gallery/service/gallery.service"
import { EventBus } from "core/event-bus/event-bus"
import IconButton from "components/UI/IconButton.vue"
import { mdiDownload } from "@mdi/js"
import { highlightsApi } from "store/api"

export default defineComponent({
  name: "EventHighlightsView",
  components: { IconButton, GalleryView, Header },
  props: {
    event: {
      type: Object as PropType<DetailedEvent>,
      required: true,
    },
    openEvent: {
      type: Object as PropType<EventBus<boolean>>,
      default: null,
    },
  },
  setup(props) {
    const loadMoreMedia: LoadGalleryMediaFunction = async (offset, limit) => {
      return getHighlightsGalleryMedia(props.event.id, offset, limit)
    }

    const isSortable = computed(() => {
      return !!props.event.links.update_url
    })

    const galleryService: GalleryService = inject("GalleryService")
    const totalEventMedia = galleryService.highlightsCount

    const handleReorder = ({ id, index }: { id: number; index: number }) => {
      galleryService.reorderHighlights({ id, index })
    }

    const onDownloadClick = () => {
      // Set the responseType to allow our axios interceptor to handle the file download
      highlightsApi.downloadHighlights(props.event.id.toString(), {
        responseType: "blob",
      })
    }

    return {
      loadMoreMedia,
      isSortable,
      totalEventMedia,
      handleReorder,
      mdiDownload,
      onDownloadClick,
    }
  },
})
</script>
